/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Error_VadInputs */



/**
* | output |
* | --- |
* | "Voice detection could not start. Please try again in a moment." |
*
* @param {Voice_Error_VadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_error_vad = /** @type {((inputs?: Voice_Error_VadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Error_VadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Spracherkennung konnte nicht gestartet werden. Bitte versuchen Sie es in einem Moment erneut.")
	return /** @type {LocalizedString} */ ("Voice detection could not start. Please try again in a moment.")
});